import { CssBaseline, ThemeProvider } from '@material-ui/core';
import React from 'react';
import { HomePage } from './home/home.page';
import theme from './theme';
import { Router } from '@reach/router';
import { ProvideAppDialog } from './app-dialog/use-app-dialog';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ProvideAppDialog>
        <Router>
          <HomePage default />
        </Router>
      </ProvideAppDialog>
    </ThemeProvider>
  );
}

export default App;
